import { render, staticRenderFns } from "./ImageUploaderDoctor.vue?vue&type=template&id=7d6afd5a&"
import script from "./ImageUploaderDoctor.vue?vue&type=script&lang=js&"
export * from "./ImageUploaderDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploaderDoctor.vue?vue&type=style&index=0&id=7d6afd5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports